import { createSDKAction, onFulfill, onPending, onReject } from '../util';
import ActionTypes from '../action-types';

export function getTaskInfo(taskId) {
  return createSDKAction(ActionTypes.GET_TASK, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.GET_TASK) });

      return sdk
        .api(`/task/${taskId}`, {
          requiresAuthentication: true
        })
        .then(response => {
          dispatch({
            type: onFulfill(ActionTypes.GET_TASK),
            payload: response.body,
            meta: { taskId }
          });

          return {
            ...response.body,
            taskId
          };
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.GET_TASK), payload: err });

          return Promise.reject(err);
        });
    }
  });
}

export function getCallUrl(taskId) {
  const { FEEDBACK_PAGE_CALL_AUDIO_POLL_INTERVAL } = window._env_;
  const callURL = `Recording/${taskId}/audio`;

  let maxRetries = 20;

  const poll = async (sdk, dispatch) => {
    let response;

    try {
      response = await sdk.api(callURL, {
        method: 'head',
        requiresAuthentication: true
      });
    } catch (err) {
      dispatch({ type: onReject(ActionTypes.POLL_CALL_AUDIO_FEEDBACK), payload: err });
      throw err;
    }

    if (response.status === 204) {
      dispatch({ type: onPending(ActionTypes.POLL_CALL_AUDIO_FEEDBACK) });

      maxRetries -= 1;

      if (!maxRetries) {
        throw new Error('Exhausted all retries whilst trying to fetch call audio');
      }

      return new Promise((...args) => {
        setTimeout(() => poll(sdk, dispatch).then(...args), FEEDBACK_PAGE_CALL_AUDIO_POLL_INTERVAL);
      });
    }

    dispatch({ type: onFulfill(ActionTypes.POLL_CALL_AUDIO_FEEDBACK) });

    return sdk.buildUrl(callURL);
  };

  return createSDKAction(ActionTypes.POLL_CALL_AUDIO_FEEDBACK, {
    callback: poll
  });
}

export function getPendingTasks() {
  return createSDKAction(ActionTypes.GET_PENDING_TASKS, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.GET_PENDING_TASKS) });

      return sdk
        .api(`/task/pendingTask`, {
          requiresAuthentication: true
        })
        .then(response => {
          dispatch({ type: onFulfill(ActionTypes.GET_PENDING_TASKS), payload: response.body });

          return response.body;
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.GET_PENDING_TASKS), payload: err });

          return Promise.reject(err);
        });
    }
  });
}

export function completeTask(taskId, result, feedback = '') {
  return createSDKAction(ActionTypes.COMPLETE_TASK, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.COMPLETE_TASK) });

      return sdk
        .api(`task/${taskId}/complete`, {
          body: {
            Result: result,
            Feedback: feedback
          },
          method: 'post',
          requiresAuthentication: true
        })
        .then(response => {
          dispatch({ type: onFulfill(ActionTypes.COMPLETE_TASK) });

          return response.body;
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.COMPLETE_TASK), payload: err });

          return Promise.reject(err);
        });
    }
  });
}

export function clearTask() {
  return createSDKAction(ActionTypes.CLEAR_TASK, {
    callback: (sdk, dispatch) => {
      dispatch({ type: ActionTypes.CLEAR_TASK });

      return Promise.resolve();
    }
  });
}
